import { render } from "./Home.vue?vue&type=template&id=87f83a62"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=87f83a62&lang=css"

import exportComponent from "C:\\PROJEKTE\\SLP_DE\\APP\\sjp_de\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__